(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["activities-navigation"] && !Shopify.designMode) return;
  try {
    
    (function () {
        const activitiesRoot = document.querySelector('[data-activities]');
        if (!activitiesRoot) return;

            const items = activitiesRoot.querySelectorAll('[data-activity-item]');
            const images = activitiesRoot.querySelectorAll('[data-activity-image]');

            function activate(index) {
            items.forEach(item => item.classList.remove('is-active'));
            images.forEach(img => img.classList.remove('is-active'));

            items[index]?.classList.add('is-active');
            images[index]?.classList.add('is-active');
        }

        items.forEach(item => {
        item.addEventListener('mouseenter', function () {
            const index = Number(this.dataset.index);
            activate(index);
        });
        });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  document.addEventListener('click', function (event) {
    const searchBar = document.getElementById('search-bar');
    const searchToggles = document.querySelectorAll('.js-show-search, .js-show-search-left');
    const header = document.querySelector('store-header');

    if (!searchBar) return;

    const clickedInsideSearch = searchBar.contains(event.target);
    const clickedToggle = Array.from(searchToggles).some((toggle) => toggle.contains(event.target));

    // ✅ Also ignore clicks on the overlay (handled by its own listener)
    const clickedOverlay = event.target.closest('.js-search-overlay');

    if (!clickedInsideSearch && !clickedToggle && !clickedOverlay) {
      const predictiveSearch = document.querySelector('predictive-search');
      if (predictiveSearch && predictiveSearch.close) {
        predictiveSearch.close(event);
      }

      header.classList.remove('search-is-visible', 'search-is-visible-hold');
      header.classList.add('search-is-collapsed');
      document.body.classList.remove('overflow-hidden', 'fixed');
    }
  });

  document.addEventListener('click', function (event) {
    const closeBtn = event.target.closest('.search__close');
    if (!closeBtn) return;

    const predictiveSearch = document.querySelector('predictive-search');
    if (predictiveSearch && predictiveSearch.close) {
      // Pass the event so close() can detect it came from the close button
      predictiveSearch.close(event);
    }

    document.activeElement.blur();

    setTimeout(() => {
      document.body.classList.remove('overflow-hidden', 'fixed', 'overlay-predictive-search');
      const header = document.querySelector('store-header');
      if (header) {
        header.classList.remove('search-is-visible', 'search-is-visible-hold');
        header.classList.add('search-is-collapsed');
      }
    }, 50);
  });

  } catch(e) { console.error(e); }
})();
})();
